import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { FreeTrialEndedModal } from "../components/common/FreeTrialEndedModal";
import { NewCaseDialog } from "../features/newCase";
import { useFreeTrialStatus } from "../hooks/useFreeTrialStatus";
import { CasesCmsSwitch } from "./CasesCmsSwitch";

/**
 * `/cases/new` (deep links, `?clientId=`): the New Case modal over the Cases
 * list. Closing it leaves the list; creating the case opens it.
 */
export const NewCase = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { daysLeft } = useFreeTrialStatus();
  const [showTrialEndedModal, setShowTrialEndedModal] = useState(false);

  useEffect(() => {
    if (daysLeft !== null && daysLeft <= 0) {
      setShowTrialEndedModal(true);
    }
  }, [daysLeft]);

  const initialClientId = searchParams.get("clientId")?.trim() || null;

  return (
    <>
      <CasesCmsSwitch />
      <NewCaseDialog
        open={!showTrialEndedModal}
        onOpenChange={(open) => {
          if (!open) navigate("/cases", { replace: true });
        }}
        initialClientId={initialClientId}
      />
      <FreeTrialEndedModal
        inCase
        isOpen={showTrialEndedModal}
        onClose={() => setShowTrialEndedModal(false)}
      />
    </>
  );
};
